export class PartExchangeImageFile{
    constructor(
        public filename: string, public filetype: string = null, public uploadUri : string = null,
        public imagePath: string = null, public thumbnailPath: string = null, public isError: boolean = false, public errorMessage: string =null
    ) {}
}